module.exports = __webpack_public_path__ + "static/media/online-shop-mobile.01683be2.svg";